import { FormatGroupLabel } from './FormatGroupLabel';

export default FormatGroupLabel;

